import { useRef, useState } from "react";

interface AppStoreButtonProps {
  className?: string;
  size?: "md" | "lg";
}

export default function AppStoreButton({ className = "", size = "md" }: AppStoreButtonProps) {
  const [show, setShow] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleClick = () => {
    setShow(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setShow(false), 2200);
  };

  return (
    <div className={`relative inline-block ${className}`}>
      <button
        type="button"
        onClick={handleClick}
        className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 font-semibold text-background-950 transition-colors hover:bg-primary-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2 focus-visible:ring-offset-background-950 ${
          size === "lg" ? "px-6 py-3.5 text-base" : "px-5 py-2.5 text-sm"
        }`}
      >
        <i className="ri-apple-fill text-lg" aria-hidden="true"></i>
        前往 App Store
        <span className="ml-1 rounded-full bg-background-950/15 px-2 py-0.5 text-xs font-medium text-background-950">
          即將上架
        </span>
      </button>

      {show && (
        <span
          role="status"
          className="absolute left-1/2 top-full z-50 mt-3 -translate-x-1/2 whitespace-nowrap rounded-md border border-background-700 bg-background-900 px-3 py-2 text-xs text-foreground-200"
        >
          keepvox 即將上架，敬請期待
        </span>
      )}
    </div>
  );
}